import { Coord } from "../../../../../src/types/Interface";


export default function calcGuideLinePoints(pStart: Coord, pEnd: Coord, length: number) {
  const angle = Math.atan2(pStart.y - pEnd.y, pStart.x - pEnd.x);
  const p = {
    x: pStart.x + Math.cos(angle) * length,
    y: pStart.y + Math.sin(angle) * length
  }
  return [pStart, p];
}